<template>
  <div class="company-introduction-view">
    <IntroductionContent1 />
    <IntroductionContent2 />
    <IntroductionContent3 />
    <IntroductionContent4 />
    <IntroductionContent5 />
    <HomeFooter v-if="showFooter" />
  </div>
</template>

<script>
import HomeFooter from '@/components/HomeFooter/HomeFooter.vue';
import IntroductionContent1 from './IntroducitonContent1.vue';
import IntroductionContent2 from './IntroducitonContent2.vue';
import IntroductionContent3 from './IntroducitonContent3.vue';
import IntroductionContent4 from './IntroducitonContent4.vue';
import IntroductionContent5 from './IntroducitonContent5.vue';

export default {
  name: 'CompanyIntroduction',
  components: {
    IntroductionContent1,
    IntroductionContent2,
    IntroductionContent3,
    IntroductionContent4,
    IntroductionContent5,
    HomeFooter,
  },
  computed: {
    showFooter() {
      // 从当前路由和父路由中查找 showFooter
      const { matched } = this.$route;
      for (let i = matched.length - 1; i >= 0; i -= 1) {
        if (matched[i].meta?.showFooter !== undefined) {
          return matched[i].meta.showFooter;
        }
      }
      return false;
    },
  },
};
</script>

<style lang="less" scoped>
.company-introduction-view {
  position: relative;
  z-index: 0;
  width: 100%;
  margin: 0 auto;
  min-height: 100vh;
  background: #000;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: center;
  overflow: hidden;
}
</style>
